export const messages = {
  en: {
    housekeepingServDetail: {
      title: 'Work Order Details',
      back: 'Back',
      workOrderCode: 'Work Order Code',
      serviceName: 'Service Name',
      applicant: 'Applicant',
      contact: 'Contact',
      serviceType: 'Service Type',
      appointmentTime: 'Appointment Time',
      status: 'Status',
      remark: 'Remark',
      visitSatisfaction: 'Visit Satisfaction',
      visitContent: 'Visit Content',
      beforeRepairPhotos: 'Before Repair Photos',
      afterRepairPhotos: 'After Repair Photos',
      relatedItems: 'Related Items',
      itemCode: 'Item Code',
      itemType: 'Item Type',
      itemName: 'Item Name',
      itemSpec: 'Item Specification',
      itemQuantity: 'Item Quantity',
      itemPrice: 'Item Price',
      user: 'User',
      time: 'Time',
      workOrderFlow: 'Work Order Flow',
      sequence: 'Sequence',
      handler: 'Handler',
      processTime: 'Process Time',
      timeConsuming: 'Time Consuming',
      opinion: 'Opinion',
      satisfied: 'Satisfied',
      unsatisfied: 'Unsatisfied'
    }
  },
  zh: {
    housekeepingServDetail: {
      title: '工单详情',
      back: '返回',
      workOrderCode: '工单编码',
      serviceName: '服务名称',
      applicant: '申请人',
      contact: '联系方式',
      serviceType: '服务类型',
      appointmentTime: '预约时间',
      status: '状态',
      remark: '备注',
      visitSatisfaction: '回访满意度',
      visitContent: '回访内容',
      beforeRepairPhotos: '维修前图片',
      afterRepairPhotos: '维修后图片',
      relatedItems: '相关物品',
      itemCode: '物品资源编号',
      itemType: '物品资源类型',
      itemName: '物品资源名称',
      itemSpec: '物品资源规格',
      itemQuantity: '物品使用数量',
      itemPrice: '物品价格',
      user: '使用人',
      time: '时间',
      workOrderFlow: '工单流转',
      sequence: '序号',
      handler: '处理人',
      processTime: '处理时间',
      timeConsuming: '耗时',
      opinion: '意见',
      satisfied: '满意',
      unsatisfied: '不满意'
    }
  }
}